<h1 class="text-dark text-xl" mat-dialog-title>Nuovo Veicolo Usato</h1>
<div class="w-full" mat-dialog-content>
  <app-used-vehicle-form
    [closeDialogEvent]="closeDialogEvent"
    [isNew]="true"
    [refreshUsedVehicleTable]="refreshUsedVehicleEvent"
  ></app-used-vehicle-form>
</div>
